module.exports = __webpack_public_path__ + "img/b-yu-icon.af88527b.png";